<template>
  <div class="banner">
    <div class="banner_text">
      <div class="wenzi">
        <img src="../../assets/img/pc/text.png" />
        <img src="../../assets/img/pc/text2.png" />      
      </div>
       
    </div>
  </div>
</template>

<script>
export default {
  name: "banner", 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 8.4rem;
  position: relative;
  background: url("../../assets/img/pc/banner.png") no-repeat center;
  background-size: 100% 100%;
  
  .banner_text {
    position: absolute;
    width: 100%;
    height: auto;
    top: 50%; 
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 1;
    text-align: center;
    .wenzi { 
      width: 60%;
      margin: auto;
      img {
        width: 100%;
      }
      >img+img{
        margin-top: 0.2rem;
      }
    }
    .info{
      width: 68%;
      height: auto;
      padding: 0.36rem 1.01rem 0.85rem;
      position: absolute;
      bottom: -0.36rem;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      box-sizing: border-box;
      .info-bg{
        width: 13.18rem;
        height: 2.73rem;
        position: absolute;
        bottom: 0; 
        left: 0;
        z-index: 1;
      }
      .text{
        width: 100%;
        z-index: 2;
        position: relative;
        font-size:0.2rem; 
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.5em;
        letter-spacing: 0.02rem;
        text-align: left;
        display: inline-block;
      }
    }
    .wenzi1 {
      margin-bottom: 0.4rem;
      width: 10.68rem;
      margin-left: 1.5rem;
      img {
        width: 100%;
      }
    }
    .wenzi2 {
      font-size: 0.34rem;
      line-height: 0.6rem;
      color: #fbf5b8; 
    }
  }
}
</style>
